import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable(
    {providedIn: 'root'}
)
export class AuthGuard implements CanActivate {
    constructor(private authService: AuthService) {
    }

    canActivate(): Observable<boolean> {
        return of(this.authService.loggedIn());
    }
}
